import familyHttp from "./familyHttp";

const PREFIX = "/web/family/patients";

function unwrap(res) {
  const body = res && res.data;
  if (!body || typeof body !== "object") {
    throw new Error("服务无响应");
  }
  if (body.success || body.code === 1) {
    return body.data;
  }
  throw new Error(body.msg || "请求失败");
}

export const familyPatientApi = {
  async list() {
    const res = await familyHttp.get(PREFIX);
    return unwrap(res) || [];
  },

  async save(payload) {
    const res = await familyHttp.post(PREFIX, payload);
    return unwrap(res);
  },

  async remove(id) {
    const res = await familyHttp.delete(`${PREFIX}/${id}`);
    return unwrap(res);
  },
};
